import { ExternalUserState } from '@zaoblako/web/modules/security/components/external-user/card/models/external-user-state';

export const externalUserInitialState: ExternalUserState = {
  loading: true,
  loadingInvite: false,
  loadingChangeStatus: false,
  user: null,
  accessRights: null,
  panelsInfo: {
    accessCardsShow: true,
    accessControlShow: true
  },
  accessCardsInfo: {
    cards: [],
    loading: true,
    loadingIcon: false
  },
  accessControlInfo: {
    settings: null,
    loading: true,
    loadingButton: false
  }
};
